// extracted by mini-css-extract-plugin
export default {"container":"SocialIconsContactpage_container__uTs5y","SocialIcons":"SocialIconsContactpage_SocialIcons__rOG5j","Icons":"SocialIconsContactpage_Icons__6jKiT"};